import { createRoot } from 'react-dom/client';

import Root from './components/Root';

// Rename "Publisher" → "Affiliate" across the entire UI
(() => {
  const replacements: [RegExp, string][] = [
    [/Publishers/g, 'Affiliates'],
    [/Publisher/g, 'Affiliate'],
    [/publishers/g, 'affiliates'],
    [/publisher/g, 'affiliate'],
  ];

  const replace = (text: string): string => {
    let result = text;
    for (const [pattern, replacement] of replacements) {
      result = result.replace(pattern, replacement);
    }

    return result;
  };

  const processNode = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      if (text && /[Pp]ublisher/i.test(text)) {
        node.textContent = replace(text);
      }
    }
  };

  const walk = (root: Node) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      processNode(walker.currentNode);
    }
  };

  const observer = new MutationObserver((mutations) => {
    observer.disconnect();
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            processNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            walk(node);
          }
        }
      } else if (mutation.type === 'characterData') {
        processNode(mutation.target);
      }
    }
    observer.observe(document.body, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  });

  observer.observe(document.body, {
    characterData: true,
    childList: true,
    subtree: true,
  });
})();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Root />);
